import { LAST_WATCHED_CLEAR_EPGS, LAST_WATCHED_GET_EPGS } from 'common/constants/action-types';

export default (state = null, { payload, type }) => {
  switch (type) {
    case LAST_WATCHED_GET_EPGS:
      return payload;
    case LAST_WATCHED_CLEAR_EPGS:
      return null;
    default:
      return state;
  }
};
